
import i18n from '@/i18n';
import {ELEMENT_TYPES, WALL_TYPES} from '@/constants';

const ELEMENTS_FIELDS_LOOKUP = {
    [ELEMENT_TYPES.TYPE_BEAM]: [
        {
            name: 'height',
            label: i18n.t('Height'),
            append: 'm'
        },
        {
            name: 'width',
            label: i18n.t('Width'),
            append: 'm'
        }
    ],
    [ELEMENT_TYPES.TYPE_JUT]: [
        {
            name: 'height',
            label: i18n.t('Height'),
            append: 'm'
        },
        {
            name: 'length',
            label: i18n.t('Length'),
            append: 'm'
        }
    ],
    [ELEMENT_TYPES.TYPE_PLINTH]: [
        {
            name: 'height',
            label: i18n.t('Height'),
            append: 'm'
        }
    ],
    [ELEMENT_TYPES.TYPE_WALL_CHEST]: [
        {
            name: 'width',
            label: i18n.t('Width'),
            append: 'm'
        }
    ],
    [ELEMENT_TYPES.TYPE_WALL_RECESS]: [
        {
            name: 'area',
            label: i18n.t('Area'),
            append: 'm<sup>2</sup>'
        },
        {
            name: 'soffit',
            label: i18n.t('Soffit'),
            append: 'm'
        }
    ],
    [ELEMENT_TYPES.TYPE_PIER]: [
        {
            name: 'height',
            label: i18n.t('Height'),
            append: 'm'
        },
        {
            name: 'width',
            label: i18n.t('Width'),
            append: 'm'
        },
        {
            name: 'soffit',
            label: i18n.t('Soffit'),
            append: 'm'
        }
    ],
    [ELEMENT_TYPES.TYPE_ROUND_PIER]: [
        {
            name: 'height',
            label: i18n.t('Height'),
            append: 'm'
        },
        {
            name: 'diameter',
            label: i18n.t('Diameter'),
            append: 'm'
        },
    ],
    [ELEMENT_TYPES.TYPE_MOULDING]: [
        {
            name: 'area',
            label: i18n.t('Area'),
            type: 'number',
            step: 'any',
            append: 'm<sup>2</sup>'
        }
    ],
    [ELEMENT_TYPES.TYPE_WINDOW]: [
        {
            name: 'height',
            label: i18n.t('Height'),
            append: 'm'
        },
        {
            name: 'width',
            label: i18n.t('Width'),
            append: 'm'
        },
        {
            name: 'soffit',
            label: i18n.t('Soffit'),
            append: 'm'
        }
    ],
    [ELEMENT_TYPES.TYPE_DOOR]: [
        {
            name: 'height',
            label: i18n.t('Height'),
            append: 'm'
        },
        {
            name: 'width',
            label: i18n.t('Width'),
            append: 'm'
        }
    ],
    [ELEMENT_TYPES.TYPE_WINDOW_SILL]: [
        {
            name: 'height',
            label: i18n.t('Height'),
            append: 'm'
        },
        {
            name: 'soffit',
            label: i18n.t('Soffit'),
            append: 'm'
        },
    ],
    [ELEMENT_TYPES.TYPE_SOFFIT]: [
        {
            name: 'height',
            label: i18n.t('Height'),
            append: 'm'
        },
        {
            name: 'width',
            label: i18n.t('Width'),
            append: 'm'
        },
    ],
    [ELEMENT_TYPES.TYPE_CORNER_CASE]: [
        {
            name: 'height',
            label: i18n.t('Height'),
            append: 'm'
        },
        {
            name: 'width',
            label: i18n.t('Width'),
            append: 'm'
        },
        {
            name: 'depth',
            label: i18n.t('Depth'),
            append: 'm'
        },
    ],
    [ELEMENT_TYPES.TYPE_WALL_CENTER_CASE]: [
        {
            name: 'height',
            label: i18n.t('Height'),
            append: 'm'
        },
        {
            name: 'width',
            label: i18n.t('Width'),
            append: 'm'
        },
        {
            name: 'depth',
            label: i18n.t('Depth'),
            append: 'm'
        },
    ],
    [ELEMENT_TYPES.TYPE_BEAM_CEILING_CASE]: [
        {
            name: 'height',
            label: i18n.t('Height'),
            append: 'm'
        },
        {
            name: 'width',
            label: i18n.t('Width'),
            append: 'm'
        },
        {
            name: 'length',
            label: i18n.t('Length'),
            append: 'm'
        },
    ],
    [ELEMENT_TYPES.TYPE_CENTER_BEAM_CEILING_CASE]: [
        {
            name: 'height',
            label: i18n.t('Height'),
            append: 'm'
        },
        {
            name: 'width',
            label: i18n.t('Width'),
            append: 'm'
        },
        {
            name: 'length',
            label: i18n.t('Length'),
            append: 'm'
        },
    ],
    [ELEMENT_TYPES.TYPE_TUBE]: [
        {
            name: 'length',
            label: i18n.t('Length'),
            append: 'm'
        },
    ],
    [ELEMENT_TYPES.TYPE_FRAME]: [
        {
            name: 'quantity',
            label: i18n.t('Quantity'),
            append: i18n.t('pieces')
        },
    ],


    [ELEMENT_TYPES.TYPE_TRAPEZOID]: [
        {
            name: 'a',
            label: i18n.t('Short edge'),
            append: 'm'
        },
        {
            name: 'b',
            label: i18n.t('Long edge'),
            append: 'm'
        },
        {
            name: 'c',
            label: i18n.t('Trapezoid leg 1'),
            append: 'm'
        },
        {
            name: 'd',
            label: i18n.t('Trapezoid leg 2'),
            append: 'm'
        },
        {
            name: 'h',
            label: i18n.t('Height'),
            append: 'm'
        },
    ],
}

export default ELEMENTS_FIELDS_LOOKUP;
